export default "__VITE_ASSET__CmbmgShh__"